module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('el-dialog', {
    attrs: {
      "width": "50%",
      "title": "Avvertenze",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_vm._c('div', [_vm._v("\n    Prima di proseguire è necessario visualizzare le\n    "), _vm._c('a', {
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(". "), _vm._c('br'), _vm._c('br'), _vm._v("\n    Cliccando su\n    "), _vm._c('span', {
    staticStyle: {
      "color": "#00377c"
    }
  }, [_vm._c('b', [_vm._v("\"Accetto\"")])]), _vm._v("\n    l’utente dichiara di aver preso visione dell’avviso.\n  ")]), _vm._v(" "), _vm._c('br'), _vm._v(" "), _vm._c('span', [_vm._c('el-checkbox', {
    on: {
      "change": _vm.toggleSubmit
    }
  }, [_vm._v("Dichiaro di aver preso visione delle Avvertenze")])], 1), _vm._v(" "), _vm._c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_vm._c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._c('span', {
    staticStyle: {
      "color": "#00377c",
      "font-weight": "bold"
    }
  }, [_vm._v("Annulla")])]), _vm._v(" "), _vm._c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.submitDisabled
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._c('span', {
    staticStyle: {
      "color": "#ffffff",
      "font-weight": "bold"
    }
  }, [_vm._v("Accetto")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3851576a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfermaDettaglio.vue
// module id = 845
// module chunks = 39